import { render, staticRenderFns } from "./checkboxes.vue?vue&type=template&id=5e2756f9"
import script from "./checkboxes.js?vue&type=script&lang=js&external"
export * from "./checkboxes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports